import React from 'react';
import App from './App';
import { createBrowserRouter } from 'react-router-dom';
import ErrorPage from './pages/ErrorPage/ErrorPage';
import SignUp from 'pages/SignUp/SignUp';
import { preciousChildPaths, governmentPaths, pagePaths, tabletPaths, mindupAdminMobilePaths, connectMindPaths } from 'constants/path';
import Login from 'pages/Login/Login';
import AddDiagnosisPage from 'pages/Admin/DCK/AddDiagnosisPage/AddDiagnosisPage';
import DiagnosisListPage from 'pages/DCK/DiagnosisListPage/DiagnosisListPage';
import TodayDiagnosisPage from 'pages/DCK/TodayDiagnosisPage/TodayDiagnosisPage';
import ManagingPatientsPage from 'pages/DCK/ManagingPatients/ManagingPatientsPage';
import UserSettingPage from 'pages/UserInfo/UserSettingPage';
import HospitalSettingPage from 'pages/DCK/HospitalSettingPage/HospitalSettingPage';
import PrivateRoute, { MindUpAdminPrivateRoute } from 'components/Common/PrivateRoute';
import ViewDetailPatientPage from 'pages/DCK/ViewDetailPatientPage/ViewDetailPatientPage';
import Home from 'pages/DCK/Home/Home';
import ViewDetailDiagnosisPage from 'pages/DCK/ViewDetailDiagnosisPage/ViewDetailDiagnosisPage';
import ManagerLogin from 'pages/tablet/ManagerLogin';
import PatientLogin from 'pages/tablet/PatientLogin';
import StartExamination from 'pages/tablet/StartExamination';
import Information from 'pages/tablet/Information';
import TabletApp from 'pages/tablet/TabletApp';
import UserSurvey from 'pages/tablet/UserSurvey';
import ScrollToTop from 'components/Common/ScrollToTop';
import AdminDiagnosisListPage from 'pages/Admin/DCK/AdminDiagnosisListPage/AdminDiagnosisListPage';
import AdminCalculatePage from 'pages/Admin/DCK/AdminSettlement/AdminCalculatePage';
import GovernmentAgreePage from 'pages/Government/Agree/GovernmentAgreePage';
import GovernmentCodeConfirmPage from 'pages/Government/CodeConfirm/GovernmentCodeConfirmPage';
import GovernmentApp from 'pages/Government/GovernmentApp';
import GovernmentReadyPage from 'pages/Government/Confirm/GovernmentReadyPage';
import GovernmentSelectAssessmentPage from 'pages/Government/SelectAssessment/GovernmentSelectAssessmentPage';
import GovernmentInspectionGuidePage from 'pages/Government/InspectionGuide/GovernmentInspectionGuidePage';
import GovermentUserInspectionPage from 'pages/Government/UserInspection/GovermentUserInspectionPage';
import GovernmentCompletePage from 'pages/Government/Complete/GovernmentCompletePage';
import AdminManageUserJoinPage from 'pages/Admin/DCK/AdminManageUserJoin/AdminManageUserJoinPage';
import AdminManageHospitalPage from 'pages/Admin/DCK/AdminManageHospitalPage/AdminManageHospitalPage';
import PreciousChildApp from 'pages/MindUp/PreciousChildApp';
import InspectionGuidePage from 'pages/MindUp/Assessments/InspectionGuidePage';
import CounselReservationPage from 'pages/MindUp/CounselReservation/CounselReservationPage';
import VerificationPage from 'pages/MindUp/Verification/VerificationPage';
import PreciousAssessmentScript from 'pages/MindUp/AssessmentScript/PreciousAssessmentScript';
import AgreementPage from 'pages/MindUp/Agreement/AgreementPage';
import DetailLegalInfo from 'pages/MindUp/Agreement/DetailLegalInfo';
import CompletePage from 'pages/MindUp/Complete/CompletePage';
import ResultPage from 'pages/MindUp/Result/ResultPage';
import InspectionIntroducePage from 'pages/MindUp/Assessments/InspectionIntroducePage';
import InputChildInfoPage from 'pages/MindUp/ClientInfo/InputChildInfoPage';
import InputParentInfoPage from 'pages/MindUp/ClientInfo/InputParentInfoPage';
import InputCounselReasonPage from 'pages/MindUp/ClientInfo/InputCounselReasonPage';
import EnterancePage from 'pages/MindUp/Enterance/EnterancePage';
import MindUpAdminTodayDiagnosisPage from 'pages/Admin/MindUp/MindUpAdminTodayDiagnosis/MindUpAdminTodayDiagnosisPage';
import MindUpAdminAllReservationDiagnosisListPage from 'pages/Admin/MindUp/MindUpAdminAllReservationConsultationPage/MindUpAdminAllReservationConsultationPage';
import MindUpAdminConsultationListPage from 'pages/Admin/MindUp/MindUpAdminDiagnosisListPage/MindUpAdminConsultationListPage';
import MindupAdminUserReservationConsultationPage from 'pages/Admin/MindUp/MindupAdminUserReservationConsultation/MindupAdminUserReservationConsultationPage';
import AdminVoucherListPage from 'pages/Admin/DCK/AdminVoucherListPage/AdminVoucherList';
import MindUpAdminMobileApp from 'pages/Admin/MindUpMobile/MindUpAdminMobileApp';
import MindUpAdminMobileLogin from 'pages/Admin/MindUpMobile/MindUpAdminMobileLogin/MindUpAdminMobileLoginPage';
import MindUpAdminMobileUserReservationConsultationPage from 'pages/Admin/MindUpMobile/MindUpAdminMobileUserReservationConsultation/MindUpAdminMobileUserReservationConsultationPage';
import MindUpAdminMobileDetailDiagnosisPage from 'pages/Admin/MindUpMobile/MindUpAdminMobileDetailDiagnosis/MindUpAdminMobileDetailDiagnosisPage';
import MindUpAdminMobileAllReservationConsultationPage from 'pages/Admin/MindUpMobile/MindUpAdminMobileAllReservationConsultation/MindUpAdminMobileAllReservationConsultationPage';
import AdminCounselerListPage from 'pages/Admin/DCK/AdminCounselerListPage/AdminCounselerList';
import MindUpAdminMobileCompletedUserCounselPage from 'pages/Admin/MindUpMobile/MindUpAdminMobileCompletedUserCounsel/MindUpAdminMobileCompletedUserCounselPage';
import MindUpAdminAccountSettingPage from 'pages/Admin/MindUpMobile/MindUpAdminAccountSetting/MindUpAdminAccountSettingPage';
import AIAnalyzePage from 'pages/MindUp/AiAnalyze/AIAnalyzePage';
import SungnamEnterancePage from 'pages/MindUp/Sungnam/Enterance/SungNamEnterancePage';
import AskToAiPage from 'pages/MindUp/Sungnam/AskToAI/AskToAiPage';
import PurchaseConselServicePage from 'pages/MindUp/Sungnam/PurchaseCounselService/PurchaseCounselService';
import TestHistoryPage from 'pages/MindUp/Sungnam/TestHistory/TestHistoryPage';
import { PreviousAssessmentsList } from 'pages/MindUp/Sungnam/PreviousAssessmentList/PreviousAssessmentListPage';
import { LinkErrorPage } from 'pages/MindUp/Sungnam/Error/LinkErrorPage';
import CLManagingPatientPage from 'pages/Admin/CL/CLManagePatientPage/CLManagingPatientPage';
import CLPatientInfoPage from 'pages/Admin/CL/CLPatientInfoPage/CLPatientInfoPage';
import CLUserLookupPage from 'pages/Admin/CL/CLUserLookupPage/CLUserLookupPage';
import CLUserDetailPage from 'pages/Admin/CL/CLUserLookupPage/CLUserDetailPage';
import AdminUserRolePage from 'pages/Admin/Settings/AdminUserRolePage';
import AdminAssessmentPaymentPage from 'pages/Admin/DCK/AdminAssessmentPayment/AdminAssessmentPaymentPage';

const router = createBrowserRouter([
    {
        path: '/',
        element: (
            <>
                <ScrollToTop />
                <App />
            </>
        ),
        errorElement: <ErrorPage />,
        children: [
            // DCK
            { path: pagePaths.login, element: <Login /> },
            { path: pagePaths.signUp, element: <SignUp /> },
            { path: pagePaths.dckHome, element: <PrivateRoute component={Home} /> },
            {
                path: pagePaths.addDiagnosis,
                element: <PrivateRoute component={AddDiagnosisPage} />,
            },
            {
                path: pagePaths.diagnosisList,
                element: <PrivateRoute component={DiagnosisListPage} />,
            },
            {
                path: pagePaths.viewDetaildiagnosis,
                element: <PrivateRoute component={ViewDetailDiagnosisPage} />,
            },
            {
                path: pagePaths.todayDiagnosis,
                element: <PrivateRoute component={TodayDiagnosisPage} />,
            },
            {
                path: pagePaths.managingPatients,
                element: <PrivateRoute component={ManagingPatientsPage} />,
            },
            {
                path: pagePaths.accountSetting,
                element: <PrivateRoute component={UserSettingPage} />,
            },
            {
                path: pagePaths.hospitalSetting,
                element: <PrivateRoute component={HospitalSettingPage} />,
            },
            {
                path: pagePaths.viewDetailPatient,
                element: <PrivateRoute component={ViewDetailPatientPage} />,
            },
            {
                path: pagePaths.adminDiagnosisList,
                element: <PrivateRoute component={AdminDiagnosisListPage} />,
            },
            {
                path: pagePaths.calculate,
                element: <PrivateRoute component={AdminCalculatePage} />,
            },
            {
                path: pagePaths.assessmentPayment,
                element: <PrivateRoute component={AdminAssessmentPaymentPage} />,
            },
            {
                path: pagePaths.adminManageUserJoin,
                element: <PrivateRoute component={AdminManageUserJoinPage} />,
            },
            {
                path: pagePaths.adminManageHospital,
                element: <PrivateRoute component={AdminManageHospitalPage} />,
            },
            // MindUp admin page
            {
                path: pagePaths.mindUpAdminTodayDiagnosis,
                element: <PrivateRoute component={MindUpAdminTodayDiagnosisPage} />,
            },
            {
                path: pagePaths.mindUpAdminUserReservationConsultation,
                element: <PrivateRoute component={MindupAdminUserReservationConsultationPage} />,
            },
            {
                path: pagePaths.mindUpAdminAllReservationConsultation,
                element: <PrivateRoute component={MindUpAdminAllReservationDiagnosisListPage} />,
            },
            {
                path: pagePaths.mindUpAdminDiagnosisList,
                element: <PrivateRoute component={MindUpAdminConsultationListPage} />,
            },
            {
                path: pagePaths.adminVoucherList,
                element: <PrivateRoute component={AdminVoucherListPage} />,
            },
            {
                path: pagePaths.adminCounselerList,
                element: <PrivateRoute component={AdminCounselerListPage} />,
            },
            {
                path: pagePaths.CLAdminManagePatient,
                element: <PrivateRoute component={CLManagingPatientPage} />,
            },
            {
                path: pagePaths.CLAdminPatientInfo,
                element: <PrivateRoute component={CLPatientInfoPage} />,
            },
            {
                path: pagePaths.CLAdminUserLookup,
                element: <PrivateRoute component={CLUserLookupPage} />,
            },
            {
                path: pagePaths.CLAdminUserDetail,
                element: <PrivateRoute component={CLUserDetailPage} />,
            },
            {
                path: pagePaths.SettingsAdminUserRole,
                element: <PrivateRoute component={AdminUserRolePage} />,
            },
        ],
    },
    {
        path: '/m.admin',
        element: (
            <>
                <ScrollToTop />
                <MindUpAdminMobileApp />
            </>
        ),
        errorElement: <ErrorPage />,
        children: [
            { path: mindupAdminMobilePaths.login, element: <MindUpAdminMobileLogin /> },
            { path: mindupAdminMobilePaths.mindUpAdminMobileUserReservationConsultation, element: <MindUpAdminPrivateRoute component={MindUpAdminMobileUserReservationConsultationPage} /> },
            { path: mindupAdminMobilePaths.mindUpAdminMobileDetailDiagnosis, element: <MindUpAdminPrivateRoute component={MindUpAdminMobileDetailDiagnosisPage} /> },
            { path: mindupAdminMobilePaths.mindUpAdminMobileAllReservationConsultation, element: <MindUpAdminPrivateRoute component={MindUpAdminMobileAllReservationConsultationPage} /> },
            { path: mindupAdminMobilePaths.MindUpAdminMobileCompletedUserCounsel, element: <MindUpAdminPrivateRoute component={MindUpAdminMobileCompletedUserCounselPage} /> },
            { path: mindupAdminMobilePaths.MindUpAdminMobileAccountSetting, element: <MindUpAdminPrivateRoute component={MindUpAdminAccountSettingPage} /> },
        ],
    },
    {
        path: '/government',
        element: (
            <>
                <ScrollToTop />
                <GovernmentApp />
            </>
        ),
        errorElement: <ErrorPage />,
        children: [
            { path: governmentPaths.agree, element: <GovernmentAgreePage /> },
            { path: governmentPaths.ready, element: <GovernmentReadyPage /> },
            {
                path: governmentPaths.codeConfirm,
                element: <GovernmentCodeConfirmPage />,
            },
            {
                path: governmentPaths.selectAssessment,
                element: <GovernmentSelectAssessmentPage />,
            },
            {
                path: governmentPaths.inspectionGuide,
                element: <GovernmentInspectionGuidePage />,
            },
            {
                path: governmentPaths.userInspection,
                element: <GovermentUserInspectionPage />,
            },
            {
                path: governmentPaths.complete,
                element: <GovernmentCompletePage />,
            },
        ],
    },
    {
        path: '/mindup',
        element: (
            <>
                <ScrollToTop />
                <PreciousChildApp />
            </>
        ),
        errorElement: <ErrorPage />,
        children: [
            { path: preciousChildPaths.enterance, element: <EnterancePage /> },
            { path: preciousChildPaths.agreement, element: <AgreementPage /> },
            { path: preciousChildPaths.detailLegal, element: <DetailLegalInfo /> },
            { path: preciousChildPaths.codeVerification, element: <VerificationPage /> },
            { path: preciousChildPaths.childInfo, element: <InputChildInfoPage /> },
            { path: preciousChildPaths.parentInfo, element: <InputParentInfoPage /> },
            { path: preciousChildPaths.counselReason, element: <InputCounselReasonPage /> },
            {
                path: preciousChildPaths.inspectionGuide,
                element: <InspectionGuidePage />,
            },
            {
                path: preciousChildPaths.introduce,
                element: <InspectionIntroducePage />,
            },
            {
                path: preciousChildPaths.assessmentScript,
                element: <PreciousAssessmentScript />,
            },
            {
                path: preciousChildPaths.counselReservation,
                element: <CounselReservationPage />,
            },
            { path: preciousChildPaths.complete, element: <CompletePage /> },
            { path: preciousChildPaths.result, element: <ResultPage /> },
            { path: preciousChildPaths.aiAnalyze, element: <AIAnalyzePage /> },
            { path: preciousChildPaths.sungnamAskToAi, element: <AskToAiPage /> },

            { path: preciousChildPaths.testHistoryList, element: <TestHistoryPage /> },
        ],
    },
    {
        path: '/sungnam',
        element: (
            <>
                <ScrollToTop />
                <PreciousChildApp />
            </>
        ),
        errorElement: <LinkErrorPage />,
        children: [
            { path: connectMindPaths.sungnamEnterance, element: <SungnamEnterancePage /> },
            { path: connectMindPaths.sungnamAgreement, element: <AgreementPage /> },
            { path: connectMindPaths.detailLegal, element: <DetailLegalInfo /> },
            { path: connectMindPaths.childInfo, element: <InputChildInfoPage /> },
            { path: connectMindPaths.parentInfo, element: <InputParentInfoPage /> },
            { path: connectMindPaths.inspectionGuide, element: <InspectionGuidePage /> },
            { path: connectMindPaths.introduce, element: <InspectionIntroducePage /> },
            { path: connectMindPaths.assessmentScript, element: <PreciousAssessmentScript /> },
            { path: connectMindPaths.counselReservation, element: <CounselReservationPage /> },
            { path: connectMindPaths.sungnamDiagnosisHistoryList, element: <PreviousAssessmentsList /> },
            { path: connectMindPaths.sungnamError, element: <LinkErrorPage /> },
            { path: connectMindPaths.sungnamComplete, element: <CompletePage /> },
            { path: connectMindPaths.result, element: <ResultPage /> },
            { path: connectMindPaths.aiAnalyze, element: <AIAnalyzePage /> },
            { path: connectMindPaths.sungnamAskToAi, element: <AskToAiPage /> },
            { path: connectMindPaths.sungnamPurchaseCounselService, element: <PurchaseConselServicePage /> },
            { path: connectMindPaths.testHistoryList, element: <TestHistoryPage /> },
        ],
    },
    {
        path: '/tablet',
        element: <TabletApp />,
        errorElement: <ErrorPage />,
        children: [
            { path: tabletPaths.managerLogin, element: <ManagerLogin /> },
            { path: tabletPaths.login, element: <PatientLogin /> },
            { path: tabletPaths.information, element: <Information /> },
            { path: tabletPaths.startExamination, element: <StartExamination /> },
            { path: tabletPaths.userSurvey, element: <UserSurvey /> },
            { path: tabletPaths.managerLogin, element: <ManagerLogin /> },
        ],
    },
]);

export default router;
